module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "divider-logos"
  }, [_c('div', {
    staticClass: "divider-logos__container"
  }, _vm._l((_vm.props.logos), function(logo) {
    return _c('div', {
      staticClass: "divider-logos__logo"
    }, [_c('img', {
      attrs: {
        "src": logo.url
      }
    })])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2b33994","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/divider/divider-logos/divider-logos.pug
// module id = 592
// module chunks = 1